<template>
  <div class="uploadPicture-index">
    <div class="operation-flex-text">
      <div class="operation-flex-text-flex">
        <div style="flex: 1;">编辑图片</div>
        <div v-if="album_id != 0" @click="onCancel(true)" class="operation-flex-text-div">
          <span>
            操作
            <span class="iconfont icon-046"></span>
          </span>
        </div>
        <div :class="['operation-flex-text-button', sortName]" @click="sortTap()">完成</div>
        <div :class="['operation-flex-text-button-flex', moveClose]">
          <!-- @click="moveTap()" -->
          <div @click="operationMoveTap(true)">移动</div>
          <!-- @click="operationMoveTap(true)" -->
          <div @click="operationWholeTap(true)" v-if="WholeClose">全选</div>
          <div @click="operationWholeTap(false)" v-else>反选</div>
          <div @click="operationDelTap()">删除</div>
          <div @click="operationTap()" style="color: #ff0000;">完成</div>
        </div>
      </div>
    </div>

    <div style="flex: 1;overflow: hidden;display: flex;width: 100%;">
      <div class="operation-flex-box" id="box">
        <div>
          <draggable tag="ul" v-model="fileList" v-bind="dragOptions" class="uploadPicture-draggable">
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">

              <div v-for="(item, index) in fileList" :key="index" :class="[(item.image_text == '上传' && moveClose == 'operation-flex-text-button-hover') || (item.image_text == '上传' && album_id == 0) ? 'operation-flex-uploader-div' : '']">

                <div v-if="moveClose != 'operation-flex-text-button-hover' && album_id != 0 && item.image_text == '上传'" multiple @click="uploadImg()">
                  <div class="operation-flex-uploader" :style="{ 'padding-top': boxWidth * 0.2 + 'px', width: boxWidth * 0.2 + 'px', 'margin-top': boxWidth / 4 - boxWidth * 0.2 + 'px' }">
                    <div class="van-icon van-icon-photograph"></div>
                  </div>
                </div>

                <div
                  class="operation-flex-uploader"
                  :style="{ 'padding-top': boxWidth * 0.2 + 'px', width: boxWidth * 0.2 + 'px', 'margin-top': boxWidth / 4 - boxWidth * 0.2 + 'px' }"
                  v-if="item.image_text != '模板' && item.image_text != '上传'"
                >
                  <img :src="item.image_text" @click="preview(item.image_text)" />
                  <div
                    class="operation-flex-uploader-delete van-icon van-icon-clear"
                    @click="delete_img(item)"
                    v-if="moveClose != 'operation-flex-text-button-hover' && album_id != 0"
                  ></div>
                  <div class="operation-flex-uploader-delete" v-else><van-checkbox v-if="album_id != 0" v-model="item.checked" icon-size="18px"></van-checkbox></div>
                </div>

                <div
                  class="operation-flex-uploader"
                  :style="{ width: boxWidth * 0.2 + 'px', visibility: 'hidden', 'margin-top': boxWidth / 4 - boxWidth * 0.2 + 'px' }"
                  v-if="item.image_text == '模板'"
                ></div>

              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
    </div>

    <van-action-sheet v-model="show" :actions="actions" cancel-text="取消" @cancel="onCancel(false)" @select="onSelect"></van-action-sheet>
    <van-action-sheet v-model="showMove" :actions="actionsMove" cancel-text="取消" @cancel="onCancelDiv(false)" @select="onSelectMove"></van-action-sheet>
    <van-image-preview v-model="imgShow" :images="images"></van-image-preview>
  </div>
</template>

<script>
import {
  Uploader, ActionSheet, ImagePreview, Checkbox, CheckboxGroup,
} from 'vant';
import {
  Adminalbumpicgetlist,
  Adminalbumpicdel,
  Adminalbumpicupload,
  Adminalbumpicsave,
  Adminalbumpicexchange,
  Adminalbumdirectoryget,
  Adminalbumpicmove,
  AlbumweixingetMedia,
} from '@/request/api.js';
import draggable from 'vuedraggable';
import config from '@/assets/js/config.js';

export default {
  mixins: [config],
  components: {
    draggable,
    [Uploader.name]: Uploader,
    [ActionSheet.name]: ActionSheet,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      yesFileList: [],
      fileList: [{
        image_text: '上传',
      }],
      actions: [
        {
          name: '排序图片',
        },
        {
          name: '操作图片',
        },
      ],
      show: false,
      sortName: 'operation-flex-text-button-state',
      boxWidth: 0,
      images: [],
      actionsMove: [],
      showMove: false,
      drag: false,
      imgShow: false,
      moveClose: 'operation-flex-text-button-state',
      WholeClose: true,
      parent_id: 0,
      album_id: 0,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        ghostClass: 'ghost',
        disabled: this.sortName != 'operation-flex-text-button-hover',
      };
    },
  },
  created() {
    typeof WeixinJSBridge != 'undefined' && WeixinJSBridge.call('hideOptionMenu');
    this.time();
    const param = this.$api.parseUrl();
    if (param) {
      this.directory_id = param.directory_id;
      this.album_id = param.album_id;
      this.fileList_load();
    } else {
      this.$api.Message('提示', '参数出错，请重新进入').then((res) => {
        console.log(res);
      });
    }
  },
  methods: {
    uploadWxServer(localIds, wx, serverIds) {
      const _self = this;
      if (localIds.length == 0) {
        AlbumweixingetMedia({ media_ids: serverIds, directory_id: this.directory_id }).then((data) => {
          _self.fileList_load();
        });
        return;
      }
      const localId = localIds.pop();
      wx.uploadImage({
        localId, // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: (res) => {
          serverIds += serverIds.length != 0 ? `,${res.serverId}` : res.serverId; // // 返回图片的服务器端IDserverId
          _self.uploadWxServer(localIds, wx, serverIds);
        },
      });
    },
    uploadImg() {
      const _self = this;
      this.wx_config(['uploadImage', 'previewImage', 'chooseImage', 'downloadImage', 'getLocalImgData']).then((wx) => {
        wx.chooseImage({
          count: 9, // 默认9，1-9张
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: (res) => {
            res = res.localIds;
            const serverIds = '';
            _self.uploadWxServer(res, wx, serverIds);
          },
        });
      });
    },
    async fileList_load() {
      const list = [
        {
          image_text: '模板',
          pic_id: 0,
        },
        {
          image_text: '模板',
          pic_id: 0,
        },
        {
          image_text: '模板',
          pic_id: 0,
        },
        {
          image_text: '模板',
          pic_id: 0,
        },
      ];
      const res = await Adminalbumpicgetlist({
        directory_id: this.directory_id,
        album_id: this.$store.state.userInfo.album_id,
        operate_album_id: this.$store.state.userInfo.album_id,
      });
      this.fileList = [{
        image_text: '上传',
      }];
      this.fileList = this.fileList.concat(res.data.concat(list));
      this.fileList = this.fileList.map((item) => ({
        image_text: item.image_text,
        pic_id: item.pic_id,
        checkbox: false,
      }));
    },
    preview(url) {
      this.images = [url];
      this.imgShow = true;
    },
    time() {
      setTimeout(() => {
        try {
          this.boxWidth = document.getElementById('box').offsetWidth;
        } catch (e) {
          this.time();
        }
        if (this.boxWidth == 0) {
          this.time();
        }
      }, 500);
    },
    delete_img(item) {
      const _self = this;
      this.$api.Message('提示', '是否删除该图片').then((res) => {
        if (res) {
          Adminalbumpicdel({
            ids: item.pic_id,
            operate_album_id: this.$store.state.userInfo.album_id,
          }).then((res) => {
            _self.fileList_load();
          });
        }
      });
    },
    async afterRead(event) {
      const _self = this;
      let newIndex = 0;
      const newList = new Array();

      if (Object.prototype.toString.call(event) == '[object Object]') {
        event = [event];
      }

      // 此时可以自行将文件上传至服务器
      event.map((item, index) => {
        const param = new FormData();
        param.append('file', item.file, item.file.name);
        Adminalbumpicupload(param).then((res) => {
          newIndex += 1;
          const img = new Image();
          img.src = item.content;
          newList.push({
            url: res.code.url,
            image: img,
            file: (item.file.size / 1024).toFixed(1),
            title: item.file.name,
          });
          if (newIndex == event.length) {
            _self.newList_load(newList, img);
          }
        });
      });
    },
    newList_load(newList, img) {
      const _self = this;
      let widths = '';
      let heights = '';
      let sizes = '';
      let titles = '';
      let images = '';

      img.onload = () => {
        newList.map((item, index) => {
          widths += widths.length == 0 ? item.image.width : `,${item.image.width}`;
          heights += heights.length == 0 ? item.image.height : `,${item.image.height}`;
          sizes += sizes.length == 0 ? item.file : `,${item.file}`;
          titles += titles.length == 0 ? item.title : `,${item.title}`;
          images += images.length == 0 ? item.url : `,${item.url}`;
          if (index == newList.length - 1) {
            const newParam = {
              widths,
              heights,
              sizes,
              titles,
              images,
              directory_id: _self.directory_id,
              operate_album_id: _self.$store.state.userInfo.album_id,
            };
            Adminalbumpicsave(newParam).then((newRes) => {
              _self.fileList_load();
            });
          }
        });
      };
    },
    onCancel(close) {
      this.show = close;
    },
    onSelect(item) {
      this.show = false;
      if (item.name == '排序图片') {
        this.sortName = 'operation-flex-text-button-hover';
        this.yesFileList = this.fileList;
      }
      if (item.name == '操作图片') {
        this.moveClose = 'operation-flex-text-button-hover';
      }
    },
    sortTap() {
      const newList = new Array();
      this.sortName = 'operation-flex-text-button-hover-alternate';
      let str = '';
      this.fileList.map((item) => {
        if (item.pic_id) {
          str += str.length == 0 ? item.pic_id : `,${item.pic_id}`;
        }
      });

      this.yesFileList.map((item, index) => {
        if (item.pic_id != this.fileList[index].pic_id && newList.indexOf(item.pic_id) == -1 && newList.indexOf(this.fileList[index].pic_id) == -1) {
          newList.push(item.pic_id, this.fileList[index].pic_id);
          Adminalbumpicexchange({
            id1: item.pic_id,
            id2: this.fileList[index].pic_id,
            operate_album_id: this.$store.state.userInfo.album_id,
            pic_ids: str,
          }).then((res) => {
            console.log(res);
          });
        }
      });
    },
    goBack() {
      history.go(-1);
    },
    onCancelDiv(close, item) {
      this.showDiv = close;
      this.directory = close ? item : this.directory;
    },
    joinTap(item) {
      if (this.sortName != 'operation-flex-text-button-hover') {
        this.$router.push({
          path: `/uploadPicture?directory_id=${item.directory_id}`,
        });
      }
    },
    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    },
    operationTap() {
      this.moveClose = 'operation-flex-text-button-hover-alternate';
    },
    async operationMoveTap(close) {
      if (close) {
        this.parent_id = 0;
      }

      const res = await Adminalbumdirectoryget({
        parent_id: this.parent_id,
      });
      this.actionsMove = res.data.map((name, index) => ({
        name: name.name,
        order: index + 1,
        img_url: name.image_text,
        directory_id: name.directory_id,
      }));
      this.showMove = true;
    },
    async onSelectMove(event) {
      if (this.parent_id == 0) {
        this.parent_id = event.directory_id;
        this.operationMoveTap(false);
        return;
      }

      const obtainListCheckbox = this.obtainListCheckbox();

      if (obtainListCheckbox.length == 0) {
        this.$api.Message('提示', '请选择需要操作的图片').then((res) => {
          console.log(res);
        });
        return;
      }
      const res = await Adminalbumpicmove({
        ids: obtainListCheckbox,
        directory_id: event.directory_id,
      });
      this.fileList_load();
      this.showMove = false;
    },
    async operationDelTap() {
      const obtainListCheckbox = this.obtainListCheckbox();

      if (obtainListCheckbox.length == 0) {
        this.$api.Message('提示', '请选择需要操作的图片').then((res) => {
          console.log(res);
        });
        return;
      }

      const param = {
        ids: obtainListCheckbox,
      };
      const res = await this.$api.Message('提示', '是否删除选中图片?');
      if (res) {
        const newRes = await Adminalbumpicdel(param);
        this.fileList_load();
      }
    },
    operationWholeTap(data) {
      this.fileList = this.fileList.map((item) => ({
        image_text: item.image_text,
        pic_id: item.pic_id,
        checked: data,
      }));
      this.WholeClose = !this.WholeClose;
    },
    obtainListCheckbox() {
      let str = '';
      this.fileList.map((item) => {
        if (item.checked) {
          str += str.length == 0 ? item.pic_id : `,${item.pic_id}`;
        }
      });
      return str;
    },
  },
};
</script>

<style lang="less">
.uploadPicture-index {
  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;

  .operation-flex-uploader-div{
    display: none;
  }

  .operation-flex-text {
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px #d5d6d8;
    position: sticky;
    top: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .operation-flex-text-button {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    background-color: #ff0000;
    position: absolute;
    top: 0;
    right: 0;
    overflow: hidden;
    width: 100%;
  }

  .operation-flex-text-button-flex {
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }

  .operation-flex-text-button-flex > div {
    flex: 1;
    text-align: center;
  }

  .operation-flex-text-flex {
    display: flex;
    justify-content: flex-end;
    flex-wrap: nowrap;
    overflow: hidden;
    width: 90%;
    position: relative;
    padding: 5%;
    width: 100%;
  }

  .operation-flex-text-div {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    align-items: center;
    color: #999;
  }

  .operation-flex-text-div > div {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .operation-flex-text-button-state {
    transform: translateX(100%);
  }

  .operation-flex-text-button-hover {
    animation: operation-hover 0.5s forwards;
  }

  .operation-flex-text-button-hover-alternate {
    animation: operation-hover-alternate 0.5s forwards;
  }

  @keyframes operation-hover {
    0% {
      transform: translateX(100%);
    }

    100% {
      transform: translateX(0);
    }
  }

  @keyframes operation-hover-alternate {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(100%);
    }
  }

  .operation-flex-box {
    flex: 1;
    background-color: #ffffff;
    padding: 0 2%;
    margin: 3rem 3%;
    border-bottom: 1px solid #f4f4f4;
    overflow-y: auto;
  }

  .operation-flex-box > div {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .operation-flex-uploader {
    position: relative;
    background-color: #f4f4f4;
  }

  .uploadPicture-draggable > span {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .operation-flex-uploader > div:nth-child(1) {
    position: absolute;
    font-size: 1.2rem;
    color: #999;
    top: calc(50% - 0.6rem);
    left: calc(50% - 0.6rem);
  }

  .operation-flex-uploader > img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .operation-flex-uploader-delete {
    position: absolute;
    top: -8px;
    right: -8px;
    color: #969799;
    font-size: 18px;
    border-radius: 100%;
    z-index: 50;
    background-color: #ffffff;
  }

  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  .list-group {
    min-height: 20px;
  }

  .list-group-item {
    cursor: move;
  }

  .list-group-item i {
    cursor: pointer;
  }

  .uploadPicture-draggable {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
